(function () {
	'use strict';

	var module = angular.module('uwAgenda.settings.administration');
	module.controller('ProtocolItemController', ['$rootScope', 'SharedAgendaService', 'Alert', 'ProtocolService', 'Protocol', 'AppointmentTypeService', '$uibModal', ProtocolItemControllerFn]);

	/* controller for protocol item directive */
	function ProtocolItemControllerFn($rootScope, SharedAgendaService, Alert, ProtocolService, Protocol, AppointmentTypeService, $uibModal) {
		var vm = this;
		vm.isRingfoon = false;
		activate();

		// edit protocol -> open modal
		vm.edit = function () {
			editProtocol(vm.protocol, false);
		};

		// deactivate protocol
		vm.deactivate = function () {
			ProtocolService.deactivate(vm.protocol.id).then(function (result) {
				// replace item
				vm.overview.remove(vm.protocol);
				// new one
				var item = new Protocol();
				item.extend(result);
				vm.overview.add(item);

				Alert.success("Protocol was successfully deactivated");
			});
		};

		// copy for another client
		vm.copy = function () {
			// create copy
			var toCopy = new Protocol();
			toCopy.extend(vm.protocol);
			var protocolCopy = toCopy.createCopy();

			editProtocol(protocolCopy, true);
		};

		/* activation work */
		function activate() {
			vm.isRingfoon = $rootScope.isRingfoon;
		}
		
		// edit
		function editProtocol(protocol, isCopy) {

			// generate new object to interact with
			var toEdit = new Protocol();
			toEdit.extend(protocol);

			if (vm.selectedUser && vm.selectedUser.id && vm.selectedUser.id > 0) {
				// set user
				toEdit.fK_User = vm.selectedUser.id;
				toEdit.userDto = vm.selectedUser;
			} else {
				toEdit.fK_User = SharedAgendaService.currentUser().id;
				toEdit.userDto = SharedAgendaService.currentUser();
			}

			// modal 
			var modalInstance = null;

			// open modal
			modalInstance = $uibModal.open({
				backdrop: 'static',
				keyboard: false,
				animation: true,
				templateUrl: '/app/settings/administration/modules/protocols/templates/protocol-details.template.html',
				controller: 'DetailProtocolController',
				controllerAs: 'vm',
				size: 'lg',
				resolve: {
					protocol: function () {
						return toEdit;
					},
					protocolCategories: ['ProtocolCategoryService', function (ProtocolCategoryService) {
						return ProtocolCategoryService.query(false);
					}],
					appointmentTypes: ['AppointmentTypeService', function (AppointmentTypeService) {
						if (toEdit.fK_User) {
							return AppointmentTypeService.queryByUserId(toEdit.fK_User, false);
						}
					}]
				}
			});


			// when modal is closed
			modalInstance.result.then(function (item) {
				// if protocol has been copied to another client, user has to select correct filter, so we do nothing here
				if (!isCopy) {
					// updated item will be shown -> replace current                
					vm.overview.remove(vm.protocol);
					vm.overview.add(item);
				}
				else {
					vm.overview.add(item);
				}
				setHtmlContent(item);
			}, function () {
				//dismissed
			});

		}
	}
})();
